import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/deviceServices';

/**
 * Hook do parowania drukarek BambuLab
 * Można opcjonalnie przekazać toast handler dla globalnych notyfikacji
 */
export function usePairBambulabPrinter(toastHandler = null) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ hubUuid, printerData }) => {
      return apiService.pairBambulabPrinter(hubUuid, printerData);
    },
    onSuccess: (data, variables) => {
      console.log('Printer pairing successful:', data);
      
      // Wyświetl toast notification o sukcesie jeśli dostępny
      if (toastHandler) {
        toastHandler.success(
          `Drukarka ${variables.printerData.device_name} została pomyślnie sparowana!`
        );
      }
      
      // Invalidate printer queries to refresh the list
      queryClient.invalidateQueries({
        queryKey: ['printers', 'discovered', variables.hubUuid]
      });
      
      // Optionally invalidate device queries if needed
      queryClient.invalidateQueries({
        queryKey: ['devices']
      });
    },
    onError: (error, variables) => {
      // Log tylko w trybie development dla debugowania
      if (process.env.NODE_ENV === 'development') {
        console.error('Printer pairing failed:', {
          message: error.message,
          status: error.status,
          errorCode: error.response?.data?.error_code,
          printerSerial: variables.printerData?.serial_number
        });
      }

      // Wyświetl toast notification o błędzie jeśli dostępny
      if (toastHandler && error.response?.data?.status === "error") {
        const errorCode = error.response.data.error_code;
        let errorMessage = error.response.data.message || 'Nieznany błąd';
        
        // Dostosuj komunikat błędu dla użytkownika
        switch (errorCode) {
          case "ALREADY_PAIRED":
            errorMessage = "Ta drukarka jest już sparowana";
            break;
          case "AUTH_FAILED":
            errorMessage = "Nieprawidłowy kod dostępu";
            break;
          case "CONNECTION_FAILED":
          case "CONNECTION_ERROR":
            errorMessage = "Nie można połączyć się z drukarką";
            break;
          case "TIMEOUT":
            errorMessage = "Przekroczono czas oczekiwania";
            break;
          default:
            // Użyj oryginalnej wiadomości z serwera
            errorMessage = error.response.data.message || 'Nieznany błąd';
            break;
        }
        
        toastHandler.error(errorMessage);
      }
    }
  });
}

/**
 * Klucze zapytań dla operacji parowania drukarek
 */
export const pairingKeys = {
  all: ['pairing'],
  bambulab: (hubUuid) => [...pairingKeys.all, 'bambulab', hubUuid],
};
